/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkUpdateOrderInfoRequestOrdersInner } from './BulkUpdateOrderInfoRequestOrdersInner';
import {
    BulkUpdateOrderInfoRequestOrdersInnerFromJSON,
    BulkUpdateOrderInfoRequestOrdersInnerFromJSONTyped,
    BulkUpdateOrderInfoRequestOrdersInnerToJSON,
    BulkUpdateOrderInfoRequestOrdersInnerToJSONTyped,
} from './BulkUpdateOrderInfoRequestOrdersInner';

/**
 * 
 * @export
 * @interface BulkUpdateOrderInfoRequest
 */
export interface BulkUpdateOrderInfoRequest {
    /**
     * 更新対象の注文リスト（最大1000件）
     * @type {Array<BulkUpdateOrderInfoRequestOrdersInner>}
     * @memberof BulkUpdateOrderInfoRequest
     */
    orders: Array<BulkUpdateOrderInfoRequestOrdersInner>;
}

/**
 * Check if a given object implements the BulkUpdateOrderInfoRequest interface.
 */
export function instanceOfBulkUpdateOrderInfoRequest(value: object): value is BulkUpdateOrderInfoRequest {
    if (!('orders' in value) || value['orders'] === undefined) return false;
    return true;
}

export function BulkUpdateOrderInfoRequestFromJSON(json: any): BulkUpdateOrderInfoRequest {
    return BulkUpdateOrderInfoRequestFromJSONTyped(json, false);
}

export function BulkUpdateOrderInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateOrderInfoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'orders': ((json['orders'] as Array<any>).map(BulkUpdateOrderInfoRequestOrdersInnerFromJSON)),
    };
}

export function BulkUpdateOrderInfoRequestToJSON(json: any): BulkUpdateOrderInfoRequest {
    return BulkUpdateOrderInfoRequestToJSONTyped(json, false);
}

export function BulkUpdateOrderInfoRequestToJSONTyped(value?: BulkUpdateOrderInfoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orders': ((value['orders'] as Array<any>).map(BulkUpdateOrderInfoRequestOrdersInnerToJSON)),
    };
}

